export default __webpack_public_path__ + "static/media/hijab visa.0224865c.jpg";